var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: _vm.isMobile ? 'calc(100% - 65px)' : 'calc(100% - 55px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _vm.currentRound.chart && _vm.currentRound.table ? _c('activity-wrapper', {
    attrs: {
      "slot": "content",
      "allowScroll": true
    },
    slot: "content"
  }, [_c('div', {
    style: {
      display: 'flex',
      marginBottom: '32px'
    }
  }, [_c('div', {
    attrs: {
      "id": "table-label-container"
    }
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound.questionHtml
    }
  })], 1), _c('div', {
    attrs: {
      "id": "table-content-container"
    }
  }, [_c('activity-table', [_c('thead', [_c('tr', _vm._l(_vm.currentRound.table.headers, function (header) {
    return _c('th', {
      key: header.label
    }, [_vm._v("\n                " + _vm._s(header.label) + "\n              ")]);
  }), 0)]), _c('tbody', _vm._l(_vm.currentRound.table.rows, function (row, idx) {
    return _c('tr', {
      key: idx
    }, _vm._l(row.values, function (value) {
      return _c('td', {
        key: value.value
      }, [_c('div', [_vm._v(_vm._s(value.value))])]);
    }), 0);
  }), 0)])], 1)]), _c('div', {
    staticClass: "graph-container-styles"
  }, [_vm.isComplete ? _c('div', {
    class: {
      'icon-container': true,
      table: _vm.isTablet
    }
  }, [_c('success-check-solid-icon', {
    attrs: {
      "height": "26",
      "width": "37"
    }
  })], 1) : _vm._e(), _vm.showErrors ? _c('div', {
    class: {
      'icon-container': true,
      table: _vm.isTablet
    }
  }, [_c('red-x-solid-icon', {
    attrs: {
      "height": "26",
      "width": "27"
    }
  })], 1) : _vm._e(), _c('div', {
    attrs: {
      "id": "graph-container"
    }
  }, [_c('bar-graph', {
    attrs: {
      "config": _vm.currentRound.chart,
      "graphDataSummary": _vm.graphDataSummary,
      "showErrors": _vm.showErrors,
      "showHints": _vm.showHints
    },
    on: {
      "onGraphDataChange": _vm.handleOnGraphDataChange
    }
  })], 1)])]) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }